import * as React from "react";

export default class ProductList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="table-responsive">
            <table className="product-list-view table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th className="text-center">Select </th>
                  <th>
                    Image
                    <i
                      className="ml-2 mdi mdi-alert-circle-outline"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Product primary image"
                    ></i>
                  </th>
                  <th>
                    Product name
                    <i
                      className="ml-2 mdi mdi-alert-circle-outline"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Product name"
                    ></i>
                  </th>
                  <th>
                    Stock level
                    <i
                      className="ml-2 mdi mdi-alert-circle-outline"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Product stock"
                    ></i>
                  </th>
                  <th>
                    Product SKU
                    <i
                      className="ml-2 mdi mdi-alert-circle-outline"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Product SKU"
                    ></i>
                  </th>
                  <th>
                    Price
                    <i
                      className="ml-2 mdi mdi-alert-circle-outline"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Product price"
                    ></i>
                  </th>
                  <th>
                    Action
                    <i
                      className="ml-2 mdi mdi-alert-circle-outline"
                      data-toggle="tooltip"
                      data-placement="left"
                      title="Edit product details"
                    ></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props.products &&
                  this.props.products.map((product, index) => {
                    return (
                      <tr>
                        <td>
                          <div className="pure-checkbox text-center">
                            <input
                              id={"checkbox" + product._id}
                              name="checkbox"
                              type="checkbox"
                            />
                            <label
                              htmlFor={"checkbox" + product._id}
                              className="m-0"
                            ></label>
                          </div>
                        </td>
                        <td>
                          <div className="img-wrap">
                            <div className="product-badge">
                              {" "}
                              {product.newProduct && (
                                <span
                                  className="badge badge-md badge-cosmic-latte"
                                  title="New"
                                >
                                  {" "}
                                  New{" "}
                                </span>
                              )}{" "}
                              {product.saleProduct && (
                                <span
                                  className="badge badge-md badge-cosmic-latte"
                                  title="Sale"
                                >
                                  {" "}
                                  Sale{" "}
                                </span>
                              )}
                              {product.hideProduct && (
                                <span
                                  className="badge badge-md badge-cosmic-latte"
                                  title="Hidden"
                                >
                                  {" "}
                                  Hidden{" "}
                                </span>
                              )}
                            </div>
                            <img
                              src={
                                product.images.length == 0 &&
                                "/images/products/no-image-available.jpg"
                              }
                              alt="Product Image"
                            />{" "}
                          </div>
                        </td>
                        <td>{product.name}</td>
                        <td>1010</td>
                        <td>{product.code}</td>
                        <td>
                          <div className="price-wrap">
                            {" "}
                            <span className="price-new">
                              <span className="price-symbol">₹</span>
                              {product.salePrice}
                            </span>
                            <span className="set ml-2">Each</span>{" "}
                            {product.saleProduct && (
                              <del className="price-old ml-2">
                                <span className="price-symbol">₹</span>
                                {product.listPrice}
                              </del>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="action text-center">
                            {" "}
                            <a className="mr-2" href="#" title="Visible">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M3.26777 8.68611C3.19557 8.80503 3.13561 8.91099 3.0875 9C3.13561 9.08901 3.19557 9.19497 3.26777 9.31389C3.50227 9.70014 3.86143 10.2156 4.35685 10.7294C5.3443 11.7534 6.84862 12.75 9 12.75C11.1514 12.75 12.6557 11.7534 13.6432 10.7294C14.1386 10.2156 14.4977 9.70014 14.7322 9.31389C14.8044 9.19497 14.8644 9.08901 14.9125 9C14.8644 8.91099 14.8044 8.80503 14.7322 8.68611C14.4977 8.29986 14.1386 7.78436 13.6432 7.2706C12.6557 6.24657 11.1514 5.25 9 5.25C6.84862 5.25 5.3443 6.24657 4.35685 7.2706C3.86143 7.78436 3.50227 8.29986 3.26777 8.68611ZM16.4391 9.2961C16.4392 9.29576 16.4394 9.29544 15.75 9L16.4391 9.2961C16.5199 9.10744 16.5202 8.89322 16.4394 8.70456L15.75 9C16.4394 8.70456 16.4395 8.7049 16.4394 8.70456L16.4387 8.70313L16.4379 8.70129L16.4358 8.69637L16.4293 8.68168C16.424 8.66977 16.4167 8.65366 16.4074 8.63363C16.3888 8.59358 16.3622 8.53779 16.3272 8.4685C16.2572 8.33004 16.1537 8.13703 16.0144 7.90764C15.7366 7.45014 15.3123 6.84064 14.7229 6.2294C13.5407 5.00343 11.67 3.75 9 3.75C6.32996 3.75 4.45927 5.00343 3.27708 6.2294C2.68767 6.84064 2.26335 7.45014 1.98558 7.90764C1.84631 8.13703 1.74277 8.33004 1.67284 8.4685C1.63784 8.53779 1.61117 8.59358 1.59258 8.63363C1.58328 8.65366 1.57599 8.66977 1.57068 8.68168L1.56419 8.69637L1.56205 8.70129L1.56125 8.70313L1.56093 8.7039C1.56078 8.70424 1.56064 8.70456 2.24997 8.99999L1.56093 8.7039C1.48007 8.89256 1.47979 9.10678 1.56064 9.29544L2.24997 8.99999C1.56064 9.29542 1.5605 9.2951 1.56064 9.29544L1.56125 9.29687L1.56205 9.29871L1.56419 9.30363L1.57068 9.31832C1.57599 9.33023 1.58328 9.34634 1.59258 9.36637C1.61117 9.40642 1.63784 9.46221 1.67284 9.5315C1.74277 9.66996 1.84631 9.86297 1.98558 10.0924C2.26335 10.5499 2.68767 11.1594 3.27708 11.7706C4.45927 12.9966 6.32996 14.25 9 14.25C11.67 14.25 13.5407 12.9966 14.7229 11.7706C15.3123 11.1594 15.7366 10.5499 16.0144 10.0924C16.1537 9.86297 16.2572 9.66996 16.3272 9.5315C16.3622 9.46221 16.3888 9.40642 16.4074 9.36637C16.4167 9.34634 16.424 9.33023 16.4293 9.31832L16.4358 9.30363L16.4379 9.29871L16.4387 9.29687L16.4391 9.2961ZM9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5ZM6 9C6 7.34315 7.34315 6 9 6C10.6569 6 12 7.34315 12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9Z"
                                  fill="black"
                                />
                              </svg>
                            </a>{" "}
                            <a className="mr-2" href="#" title="Hide">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M15.2197 1.71967C15.5126 1.42678 15.9874 1.42678 16.2803 1.71967C16.5732 2.01256 16.5732 2.48744 16.2803 2.78033L13.7228 5.33791C14.099 5.62399 14.4318 5.92752 14.7229 6.2294C15.3123 6.84064 15.7366 7.45014 16.0144 7.90764C16.1537 8.13703 16.2572 8.33004 16.3272 8.4685C16.3622 8.53779 16.3888 8.59358 16.4074 8.63363C16.4167 8.65366 16.424 8.66977 16.4293 8.68168L16.4358 8.69637L16.4379 8.70129L16.4387 8.70313L16.4391 8.7039C16.4392 8.70424 16.4394 8.70456 15.75 9C16.4394 9.29544 16.4392 9.29576 16.4391 9.2961L16.4387 9.29687L16.4379 9.29871L16.4358 9.30363L16.4293 9.31832C16.424 9.33023 16.4167 9.34634 16.4074 9.36637C16.3888 9.40642 16.3622 9.46221 16.3272 9.5315C16.2572 9.66996 16.1537 9.86297 16.0144 10.0924C15.7366 10.5499 15.3123 11.1594 14.7229 11.7706C13.5407 12.9966 11.67 14.25 9 14.25C7.66813 14.25 6.53515 13.9381 5.58732 13.4733L2.78033 16.2803C2.48744 16.5732 2.01256 16.5732 1.71967 16.2803C1.42678 15.9874 1.42678 15.5126 1.71967 15.2197L15.2197 1.71967ZM6.72521 12.3355C7.38594 12.5913 8.14144 12.75 9 12.75C11.1514 12.75 12.6557 11.7534 13.6432 10.7294C14.1386 10.2156 14.4977 9.70014 14.7322 9.31389C14.8044 9.19497 14.8644 9.08901 14.9125 9C14.8644 8.91099 14.8044 8.80503 14.7322 8.68611C14.4977 8.29986 14.1386 7.78436 13.6432 7.2706C13.3568 6.97362 13.0269 6.67895 12.6504 6.41022L11.5846 7.47602C11.8486 7.92266 12 8.44364 12 9C12 10.6569 10.6569 12 9 12C8.44364 12 7.92266 11.8486 7.47602 11.5846L6.72521 12.3355ZM8.61147 10.4492C8.73539 10.4823 8.86563 10.5 9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.86563 10.4823 8.73539 10.4492 8.61147L8.61147 10.4492ZM15.75 9L16.4394 9.29544C16.5202 9.10678 16.5202 8.89322 16.4394 8.70456L15.75 9ZM9 3.75C9.67361 3.75 10.2963 3.82978 10.87 3.96877L9.56524 5.27351C9.38201 5.25807 9.19362 5.25 9 5.25C6.84862 5.25 5.3443 6.24657 4.35685 7.2706C3.86143 7.78436 3.50227 8.29986 3.26776 8.68611C3.19557 8.80503 3.13561 8.91099 3.0875 9C3.13561 9.08901 3.19557 9.19497 3.26776 9.31389C3.48289 9.66821 3.8029 10.1313 4.23675 10.602L3.17535 11.6634C2.63854 11.0886 2.24711 10.5231 1.98558 10.0924C1.84631 9.86297 1.74277 9.66996 1.67284 9.5315C1.63784 9.46221 1.61117 9.40642 1.59258 9.36637C1.58328 9.34634 1.57599 9.33023 1.57068 9.31832L1.56419 9.30363L1.56205 9.29871L1.56125 9.29687L1.56093 9.2961C1.56078 9.29576 1.56064 9.29544 2.24984 9.00007L1.56064 9.29544C1.47979 9.10678 1.47979 8.89322 1.56064 8.70456L2.24984 8.99993C1.56064 8.70456 1.56078 8.70424 1.56093 8.7039L1.56125 8.70313L1.56205 8.70129L1.56419 8.69637L1.57068 8.68168C1.57599 8.66977 1.58328 8.65366 1.59258 8.63363C1.61117 8.59358 1.63784 8.53779 1.67284 8.4685C1.74277 8.33004 1.84631 8.13703 1.98558 7.90764C2.26335 7.45014 2.68767 6.84064 3.27708 6.2294C4.45927 5.00343 6.32996 3.75 9 3.75ZM6.0045 8.83425C6.08754 7.30936 7.30936 6.08754 8.83425 6.0045L6.0045 8.83425Z"
                                  fill="#262626"
                                />
                              </svg>
                            </a>{" "}
                            <a href="#" title="Edit">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.7074 1.94158C12.2962 1.35281 13.2508 1.35281 13.8395 1.94158L16.0584 4.16047C16.6472 4.74924 16.6472 5.70382 16.0584 6.29259L6.85629 15.4947C6.64672 15.7043 6.38003 15.8475 6.08955 15.9063L3.30699 16.47C2.81165 16.5703 2.29898 16.4158 1.9416 16.0584C1.58423 15.701 1.4297 15.1884 1.53004 14.693L2.09371 11.9104C2.15255 11.62 2.2957 11.3533 2.50527 11.1437L11.7074 1.94158ZM3.33261 13.3882L3.42955 12.9097L5.09032 14.5704L4.61175 14.6674L3.00767 14.9923L3.33261 13.3882ZM6.43545 13.7834L4.21656 11.5646L10.6887 5.09241L12.9076 7.3113L6.43545 13.7834ZM13.9736 6.24524L14.9924 5.22653L13.9263 4.16047L13.8395 4.0737L12.7735 3.00764L11.7548 4.02635L13.9736 6.24524Z"
                                  fill="#0A6CFF"
                                />
                              </svg>
                            </a>{" "}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
